import { Flex, Rectangle, Skeleton } from '@lokalise/louis';
import cuid from 'cuid';

import { randomNumberFromRange } from '@app/utils/number';

import { CellContainer, RowContainer } from '../../styles';
import { AlignedRightSkeleton, CreatedByLoadingContainer } from './styles';

const LoadingCell = ({ width, height = 15 }: { width?: string | number; height?: number }) => (
    <Skeleton animated description="Styleguides Loading">
        <Rectangle height={height} width={width ?? '100%'} />
    </Skeleton>
);

// eslint-disable-next-line react/no-multi-comp
export const LoadingSkeleton = ({ rowsCount = 5 }: { rowsCount?: number }) => (
    <>
        {Array.from({ length: rowsCount === 0 ? 5 : rowsCount }, () => randomNumberFromRange(70, 100)).map((width) => (
            <RowContainer key={cuid()}>
                <CellContainer>
                    <LoadingCell width={`${width}%`} />
                </CellContainer>
                <CellContainer>
                    <LoadingCell width={`${width}%`} />
                </CellContainer>
                <CellContainer>
                    <LoadingCell width={`${width}%`} />
                </CellContainer>
                <CellContainer>
                    <CreatedByLoadingContainer>
                        <Flex gap={1}>
                            <LoadingCell width={width} />
                            <LoadingCell height={12} width={60} />
                        </Flex>
                    </CreatedByLoadingContainer>
                </CellContainer>
                <CellContainer>
                    <LoadingCell height={30} width={`${width}%`} />
                </CellContainer>
                <CellContainer colSpan={1} align="right">
                    <AlignedRightSkeleton animated description="Styleguides Loading">
                        <Rectangle height={18} width={40} />
                    </AlignedRightSkeleton>
                </CellContainer>
            </RowContainer>
        ))}
    </>
);

export default LoadingSkeleton;
